//#region src/extensions/special-characters-extension/selected-categories-enum.ts
var e = /* @__PURE__ */ function(e) {
	return e.Text = "text", e.Currency = "currency", e.All = "all", e;
}({});
//#endregion
export { e as SelectedCategoriesEnum };
